import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'

import {
  convertStores,
  fetchStores,
  StoresResponse as Response,
  StoresData,
} from '@nextforce/api'
import { RetryQuery } from 'shared/queries/utils'
import { useUser } from 'users/queries/detail'
import keys from './shared/keys'

export function useStores<T = StoresData>(
  select?: (data: StoresData) => T,
  retryQuery?: RetryQuery
) {
  const { server } = useServer()
  const { data: user } = useUser()
  return useQuery({
    queryKey: keys.all,
    queryFn: fetch,
    retry: retryQuery ?? false,
    select,
    enabled:
      !!user?.permissions?.canSeeHelperSchedule ||
      !!user?.permissions?.canSeeStoreSchedule,
  })

  function fetch() {
    try {
      return fetchStores(server)
    } catch (err: any) {
      if (
        user?.role === 'helper' ||
        err.name === 'WAITING_FOR_STORE_MEMBERSHIP_APPROVAL'
      ) {
        return {
          stores: [],
          hasShifts: false,
        }
      }

      throw err
    }
  }
}

export function useHelperStores() {
  const { server } = useServer()
  return useQuery<StoresData>({
    queryKey: keys.helper,
    queryFn: fetchHelperStores,
  })

  async function fetchHelperStores() {
    try {
      const response = await server.get<Response.Stores>(
        '/v2/helpers/me/stores'
      )
      return convertStores(response)
    } catch (err: any) {
      return {
        stores: [],
        hasShifts: false,
      }
    }
  }
}
